import { IOpData, IReferenceType, IOpChangeState } from '../util/interfaces'
import { DataType } from '../../helpers/common-helper'
import { OpBase, OpBaseData } from '../common/op-base'
import { ReferenceType } from '../common/enums'
import { Utils } from '../util/utils'
import { Enums } from '../common/enums'
import { OpDataType } from '../core/op-data-type'


export class OpTaskData implements IOpData {

    //#region Properties

    public idTaskData: number
    public idTask: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //#endregion


    //#region NavigationProperties

    private _dataType: OpDataType = null
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value != null ? value.idDataType : null
    }

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpTaskData) {
            this.copy(<OpTaskData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IOpData Implementation

    public get idData() { return this.idTaskData }
    public set idData(idData: number) { this.idTaskData = idData }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    //#endregion


    //#endregion IJsonSerializable Implementation

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null

            this.idTaskData = opObj.ID_TASK_DATA
            this.idTask = opObj.ID_TASK
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_TASK_DATA: this.idTaskData,
            ID_TASK: this.idTask,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTaskData {
        const newTaskData: OpTaskData = new OpTaskData(null)

        newTaskData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newTaskData
    }

    public copy(source: OpTaskData, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        Utils.copyIOpData(this, source, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        this.idTask = source.idTask
        this.idTaskData = source.idTaskData
    }

    //#endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpTaskData {
        const newData: OpTaskData = new OpTaskData(null)

        newData.idTaskData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion

}